import { render } from "./EquipeChip.vue?vue&type=template&id=0f08a319&scoped=true"
import script from "./EquipeChip.vue?vue&type=script&lang=js"
export * from "./EquipeChip.vue?vue&type=script&lang=js"

import "./EquipeChip.vue?vue&type=style&index=0&id=0f08a319&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f08a319"]])

export default __exports__